import { Form as FactorialForm } from 'factorial-form'

interface FormValues {
  status: string
}

export class SurveysConfigFilters extends FactorialForm {
  constructor(values: FormValues) {
    super(values, {
      status: 'string',
    })
  }
}
